import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "placeholder",
  "use": "placeholder-usage",
  "viewBox": "0 0 1920 1080",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"none\" viewBox=\"0 0 1920 1080\" id=\"placeholder\"><path d=\"M1 1h1918v1078H1zm64 64 1790 950m0-950L65 1015\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol